import { useState } from 'react';

interface Params {
  initialPage?: number;
  initialPageSize?: number;
  initialSearch?: string;
}

export function usePagination(params?: Params) {
  const { initialPage = 0, initialPageSize = 10, initialSearch = '' } = params ?? {};

  const [page, setPage] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [search, setSearch] = useState(initialSearch);

  // Custom pageSize setter that also resets page to initial value
  const handleSetPageSize = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPage(initialPage);
  };

  // Custom search setter that also resets page to initial value
  const handleSetSearch = (newSearch: string) => {
    setSearch(newSearch);
    setPage(initialPage);
  };

  return { pageIndex: page, setPage, pageSize, setPageSize: handleSetPageSize, search, setSearch: handleSetSearch };
}
